import { render, staticRenderFns } from "./AutomationSourcePill.vue?vue&type=template&id=1590f473&scoped=true&"
import script from "./AutomationSourcePill.vue?vue&type=script&lang=js&"
export * from "./AutomationSourcePill.vue?vue&type=script&lang=js&"
import style0 from "./AutomationSourcePill.vue?vue&type=style&index=0&id=1590f473&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1590f473",
  null
  
)

export default component.exports